import { safeGet } from "../utils/safeGet";
import { API } from "./index";

export const getTiposDieta = async () => {
  return safeGet(`${API}/tipoDieta/public`, false); // false = no usar autenticación
};

export const getTipoDietaById = async (id) => {
  return safeGet(`${API}/tipoDieta/${id}`);
};

